import { render, staticRenderFns } from "./NumberRecord.vue?vue&type=template&id=21059486"
import script from "./NumberRecord.vue?vue&type=script&lang=js"
export * from "./NumberRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports